import { AppThunk } from '../../../store/rootReducer';
import { userNameSelector } from '../../auth/selectors/auth.selectors';
import { Wave } from '../../wave/types/wave.type';
import * as delineationActions from '../actions/delineation.actions';
import { userDelineationSelector } from '../selectors/delineation.selectors';
import { createUserDelineation } from '../utils/delineation.utils';

export const updateUserDelineation = (waves: Wave[]): AppThunk => (
  dispatch,
  getState,
) => {
  const userName = userNameSelector(getState());

  if (userName == null) {
    return;
  }
  const userDelineation =
    userDelineationSelector(getState()) ??
    createUserDelineation(userName, waves);

  dispatch(
    delineationActions.addDelineation({
      delineation: { ...userDelineation, waves },
    }),
  );
};
